<template>
  <!-- 能源类型 -->
  <div class="energysubtype">
    <div class="con">
      <el-button type="primary" @click="add_ed(0)" class="last-el-button">新增</el-button>
      <div class="mytable" style="margin-top:20px">
        <el-table id="demo" :height="heights" border stripe :data="tableData" style="width: 100%">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column label="名称" align="left" min-width="150">
            <template slot-scope="{row}">
              {{ row.typeName }}
            </template>
          </el-table-column>
          <el-table-column label="应用类型" width="200">
            <template slot-scope="{row}">
              {{ row.appTypeName }}
            </template>
          </el-table-column>
          <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
            align="right" :minWidth="item.width">
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template #default="{row}">
              <div class="btnss" style="display: flex;justify-content: center; align-items: center;">
                <div @click="edit_ed(row)" class="mr-20">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <elIconBtn btnType='edit'></elIconBtn>
                  </el-tooltip>
                </div>
                <div @click="delete_fn(row.id)">
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <elIconBtn btnType='del'></elIconBtn>
                  </el-tooltip>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 新增修改 -->
      <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
        width="25%" center>
        <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
          <el-form-item label="类型名称:" prop="typeName">
            <el-input v-model="temp.typeName"></el-input>
          </el-form-item>
          <el-form-item label="应用类型组:">
            <el-select v-model="temp.appType" filterable placeholder="请选择应用类型组" clearable>
              <el-option v-for="(item,i) in options" :key="i" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用类型:">
            <el-select v-model="temp.appTypeNo" filterable placeholder="请选择应用类型" clearable>
              <el-option v-for="(item,i) in typeOptions" :key="i" :label="item.name" :value="item.no">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="编号:" prop="typeCode">
            <el-input v-model="temp.typeCode"></el-input>
          </el-form-item>
          <el-form-item label="单位转换系数:">
            <el-input v-model="temp.translateRatio"></el-input>
          </el-form-item>
          <el-form-item label="折标系数:">
            <el-input v-model="temp.coefficient"></el-input>
          </el-form-item>
          <el-form-item label="碳转换系数:">
            <el-input v-model="temp.co2TranslateRatio	"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import elIconBtn from '@/components/module/iconBtns.vue'
  import {getAllEnergyType,getAllTypeByGroup,getAppTypeByGroupId,saveEnergyType,deleteEnergyType} from "../../api/energySubType";
  export default {
    components: {elIconBtn},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-200,
        loading: false,
        total: 0,
        topLevel: 0,
        detail_status: false,
        Password: '',
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        tableData: [
          {
            "id": "190c60d6e0f149ca829cad4cf7509bf7",
            "typeCode": "power",
            "typeName": "电",
            "typeFlag": 0,
            "typeParentId": "0",
            "translateRatio": 0.1,
            "coefficient": 0.2,
            "appType": "d9624af6-c056-48d9-aedc-56c08a5d173d",
            "appTypeNo": 36,
            "appTypeName": "总正向有功电量",
            "children": [],
            "co2TranslateRatio": 0.3
          },
          {
            "id": "45c010a1afbf4977b2e596366fa743a4",
            "typeCode": "steam",
            "typeName": "汽",
            "typeFlag": 0,
            "typeParentId": "0",
            "translateRatio": 2.0,
            "coefficient": 1.0,
            "appType": "2666a9ca4520424a9e4c521bd0f35b48",
            "appTypeNo": 237,
            "appTypeName": "累计流量",
            "children": [],
            "co2TranslateRatio": 3.6
          },
          {
            "id": "789f93d16f354cb2865dc7d3fa02b4ef",
            "typeCode": "gas",
            "typeName": "气",
            "typeFlag": 0,
            "typeParentId": "0",
            "translateRatio": 0.1,
            "coefficient": 0.2,
            "appType": "2666a9ca4520424a9e4c521bd0f35b48",
            "appTypeNo": 237,
            "appTypeName": "累计流量",
            "children": [],
            "co2TranslateRatio": 0.3
          },
          {
            "id": "96372937c7aa4b17ba6255eb6e64d3ae",
            "typeCode": "water",
            "typeName": "水",
            "typeFlag": 0,
            "typeParentId": "0",
            "translateRatio": 0.4,
            "coefficient": 0.5,
            "appType": "2666a9ca4520424a9e4c521bd0f35b48",
            "appTypeNo": 237,
            "appTypeName": "累计流量",
            "children": [],
            "co2TranslateRatio": 0.1
          }
        ],
        optionsd: {},
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          EnergyTypeParentId: [
            {required: true,message: '请输入父id',trigger: 'blur'}
          ],
          typeName: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
          typeCode: [
            {required: true,message: '请输入编号',trigger: 'blur'}
          ],

          Type: [
            {required: true,message: '请选择路由',trigger: 'change'}
          ],

        },
        options: [
          {
            "createTime": null,
            "id": "322b3084ed36478facef59016767d0cc",
            "name": "未定义",
            "no": 0,
            "serialnum": 1,
            "datatypetag": 0,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "31ed13da-4c8d-4d80-8ada-a3713762a49d",
            "name": "相电压",
            "no": 2,
            "serialnum": 2,
            "datatypetag": 1,
            "unit": "V",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "aec119cd-245d-4432-b97d-1a11646377c0",
            "name": "电流",
            "no": 1,
            "serialnum": 2,
            "datatypetag": 1,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "d9624af6-c056-48d9-aedc-56c08a5d173d",
            "name": "有功电能",
            "no": 3,
            "serialnum": 3,
            "datatypetag": 1,
            "unit": "kWh",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "cf19635a-e5b7-4aec-b0e3-b8acd85ba8ce",
            "name": "有功功率",
            "no": 4,
            "serialnum": 4,
            "datatypetag": 1,
            "unit": "kW",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "43e52f5c-cb53-49ed-a939-70305044eaa4",
            "name": "频率",
            "no": 5,
            "serialnum": 5,
            "datatypetag": 1,
            "unit": "Hz",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "e2c6256b-ab82-4690-b8cb-a4a33b1ad8c4",
            "name": "温度",
            "no": 7,
            "serialnum": 6,
            "datatypetag": 1,
            "unit": "℃",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "dcaef86b54924477894b573d935ee6e9",
            "name": "湿度",
            "no": 8,
            "serialnum": 7,
            "datatypetag": 1,
            "unit": "%RH",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "fb851bbfd23b44cea50ac7cbb62ddd5d",
            "name": "总尖峰平谷",
            "no": 60,
            "serialnum": 8,
            "datatypetag": 0,
            "unit": "kWh",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "2666a9ca4520424a9e4c521bd0f35b48",
            "name": "累计流量",
            "no": 9,
            "serialnum": 9,
            "datatypetag": 1,
            "unit": "m3",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "a08fdbfa38ef4126a8471f0934bc2fe9",
            "name": "开关状态",
            "no": 11,
            "serialnum": 10,
            "datatypetag": 0,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "b31af6844f9243098793ca779f139fe9",
            "name": "压力",
            "no": 10,
            "serialnum": 11,
            "datatypetag": 1,
            "unit": "Pa",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "66bc34d4302f485b8a185cb1d4677592",
            "name": "功率因数",
            "no": 13,
            "serialnum": 12,
            "datatypetag": 1,
            "unit": "cosφ",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "f28f41719a104a8a8d0e0aadfb516363",
            "name": "亮度",
            "no": 12,
            "serialnum": 13,
            "datatypetag": 1,
            "unit": "cd/m2",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "37e416b7505d483e83914de07891bf35",
            "name": "正序电流",
            "no": 30,
            "serialnum": 15,
            "datatypetag": 1,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "cd569d69dd734363824d699d36e8b5cd",
            "name": "负序电流",
            "no": 31,
            "serialnum": 18,
            "datatypetag": 1,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "6112b4ffa672403fa4fdfc740f0ff6b7",
            "name": "零序电流",
            "no": 33,
            "serialnum": 19,
            "datatypetag": 1,
            "unit": "mA",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "7b093983e8d84d768de4fdf4bf0766af",
            "name": "电压偏差",
            "no": 35,
            "serialnum": 20,
            "datatypetag": 0,
            "unit": "%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "99b9170fb1e14b368ab5472691036b8a",
            "name": "负序电压",
            "no": 36,
            "serialnum": 21,
            "datatypetag": 0,
            "unit": "V",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "6ab82e01ce0245dcbd716c263203413a",
            "name": "正序电压",
            "no": 37,
            "serialnum": 22,
            "datatypetag": 0,
            "unit": "V",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "5af3a0bd9ab44fcf8f5a8701f3e0fce7",
            "name": "零序电压",
            "no": 38,
            "serialnum": 23,
            "datatypetag": 0,
            "unit": "V",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "baf429044ce84086bea7cdaec8cbc819",
            "name": "无功功率",
            "no": 39,
            "serialnum": 24,
            "datatypetag": 0,
            "unit": "kvar",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "d9ea197686464ca792ecb41077fc1573",
            "name": "视在功率",
            "no": 40,
            "serialnum": 25,
            "datatypetag": 0,
            "unit": "kVA",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "2127db0372654a6e803645a7daeb48fd",
            "name": "频率偏差",
            "no": 41,
            "serialnum": 26,
            "datatypetag": 0,
            "unit": "f%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "a731f816411e4125a76c49c6ac16951d",
            "name": "时间",
            "no": 42,
            "serialnum": 27,
            "datatypetag": 0,
            "unit": "h",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "62aba95d8257461ebeeccc9a23527835",
            "name": "线电压",
            "no": 43,
            "serialnum": 28,
            "datatypetag": 0,
            "unit": "V",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "fd01ac4c1fc74753b18591f038d765f4",
            "name": "无功电能",
            "no": 44,
            "serialnum": 29,
            "datatypetag": 0,
            "unit": "kvarh",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "2812a71f43cd4fd1ac5404b4d42f9385",
            "name": "瞬时流量",
            "no": 45,
            "serialnum": 30,
            "datatypetag": 0,
            "unit": "m3/h",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "12472bd435744ed8b8ffb302c2b9e235",
            "name": "调光度",
            "no": 46,
            "serialnum": 31,
            "datatypetag": 0,
            "unit": "%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "931b9e3cc6b54b328a8111f82cc613a4",
            "name": "相角",
            "no": 47,
            "serialnum": 32,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "2be1be84e97c4ccfa913ae3dcaf259cd",
            "name": "K因数",
            "no": 48,
            "serialnum": 33,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "4c20865ac7ec49208fdcf004abee9a8b",
            "name": "有功需量",
            "no": 50,
            "serialnum": 34,
            "datatypetag": 0,
            "unit": "KW",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "ce01ac4c1fc74753b18591f038d765ce",
            "name": "西门子充电桩",
            "no": 49,
            "serialnum": 35,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "c70627186f0b40bcb54e409687f60b5d",
            "name": "需量",
            "no": 50,
            "serialnum": 36,
            "datatypetag": 0,
            "unit": "kw",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "4e57970f96f74245b09464962f09e2a0",
            "name": "无功需量",
            "no": 51,
            "serialnum": 37,
            "datatypetag": 0,
            "unit": "kW·h",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "4330cc707b3d4dce9ac07a5fbc2cde80",
            "name": "视在需量",
            "no": 52,
            "serialnum": 38,
            "datatypetag": 0,
            "unit": "kW·h",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "700b5db9564c42bd97a1d2d16f725d73",
            "name": "电流需量",
            "no": 53,
            "serialnum": 39,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "26ed8f078fa9404bbbe4165106b22820",
            "name": "照明",
            "no": 54,
            "serialnum": 40,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "a42b3ea9dfd24bb6ab7f548a8a78db7a",
            "name": "空调温度",
            "no": 55,
            "serialnum": 41,
            "datatypetag": 0,
            "unit": "℃",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "1831f085abfa435ea5f51b9a01839b6f",
            "name": "空调状态",
            "no": 56,
            "serialnum": 42,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "ee7926d51c734f9f8de891b1a87b4863",
            "name": "空调权限",
            "no": 57,
            "serialnum": 43,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "345a9d750d2a4009adf0d2f9f909b98c",
            "name": "人体红外",
            "no": 61,
            "serialnum": 44,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "294c9e9706c84897bac436dc20274307",
            "name": "信号强度",
            "no": 62,
            "serialnum": 45,
            "datatypetag": 0,
            "unit": "dBm",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "da2c71d085704b7eb61c5a891fd574ba",
            "name": "设备状态",
            "no": 63,
            "serialnum": 46,
            "datatypetag": 0,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "cec535339e794783b932f764d9ee12a9",
            "name": "充值电表",
            "no": 64,
            "serialnum": 47,
            "datatypetag": 0,
            "unit": "kWh",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "5f0330d6ea404867b1277b701c103aa3",
            "name": "电流谐波畸变率",
            "no": 15,
            "serialnum": 48,
            "datatypetag": 1,
            "unit": "%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "4f1506f4-3aba-4bdd-a631-8cd194bc5773",
            "name": "电压谐波畸变率",
            "no": 6,
            "serialnum": 49,
            "datatypetag": 1,
            "unit": "%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "61e72559e3c641bb8a3bdbb852a0997b",
            "name": "三相电流不平衡度",
            "no": 32,
            "serialnum": 50,
            "datatypetag": 0,
            "unit": "%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "6ba41729fae7410983f25aff22cc8cbb",
            "name": "三相电压不平衡度",
            "no": 34,
            "serialnum": 50,
            "datatypetag": 0,
            "unit": "%",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "31264cc78cb24e2cbd96f877a3fc050f",
            "name": "A相电流奇次谐波",
            "no": 18,
            "serialnum": 51,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "c787166a171d4dd4bd0b8e42f7f8f822",
            "name": "A相电流偶次谐波",
            "no": 19,
            "serialnum": 52,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "c268a034d37543899878a543c16319c3",
            "name": "B相电流奇次谐波",
            "no": 20,
            "serialnum": 53,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "7cb145e48bec44da9f8106e47a1f5bc7",
            "name": "B相电流偶次谐波",
            "no": 21,
            "serialnum": 54,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "8d878a039a354c2cacd5aaea86c04f04",
            "name": "C相电流奇次谐波",
            "no": 22,
            "serialnum": 55,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "5aeb354075454843bc6507f31744627e",
            "name": "C相电流偶次谐波",
            "no": 23,
            "serialnum": 56,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "7d71e18ff67b4ef08f351755b49fa7e9",
            "name": "A相电压奇次谐波",
            "no": 24,
            "serialnum": 57,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "a45c4b96899448d6bdd4300c019f048e",
            "name": "A相电压偶次谐波",
            "no": 25,
            "serialnum": 60,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "db8a02ae83054dc1ba4a60f51c8a2338",
            "name": "B相电压奇次谐波",
            "no": 26,
            "serialnum": 61,
            "datatypetag": 1,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "51ed3b95f4734825acfe55cf80a28256",
            "name": "B相电压偶次谐波",
            "no": 27,
            "serialnum": 62,
            "datatypetag": 0,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "9b1f5445f7f54702899327d31b3ca00d",
            "name": "C相电压奇次谐波",
            "no": 28,
            "serialnum": 63,
            "datatypetag": 0,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "43dda3a9f9e34bc0a45b434263862565",
            "name": "C相电压偶次谐波",
            "no": 29,
            "serialnum": 64,
            "datatypetag": 0,
            "unit": "",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "5fcd7ac541a24967af64539b40ce1648",
            "name": "健康指数",
            "no": 67,
            "serialnum": 67,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": null,
            "id": "5738a003d7ce49dfb0873cc22f162642",
            "name": "预测性维护",
            "no": 68,
            "serialnum": 68,
            "datatypetag": 0,
            "unit": "无",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1689729422000,
            "id": "0125e86ea9734aca8ad0980fa057d702",
            "name": "特殊能源",
            "no": 69,
            "serialnum": 69,
            "datatypetag": 0,
            "unit": "t",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696668877000,
            "id": "8fd4a17e00cb4d69ab590270ed64774a",
            "name": "电压谐波含有率",
            "no": 70,
            "serialnum": 70,
            "datatypetag": 0,
            "unit": "KV",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696668910000,
            "id": "1d7b3624d9ed43968fafbb2f07a46ddd",
            "name": "电流谐波含有率",
            "no": 71,
            "serialnum": 71,
            "datatypetag": 0,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696669943000,
            "id": "1861b8d271314793a72be5252f386766",
            "name": "A相电压谐波",
            "no": 73,
            "serialnum": 73,
            "datatypetag": 0,
            "unit": "KV",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696669967000,
            "id": "d504fbb6930546e2984f86bc5896a2db",
            "name": "B相电压谐波",
            "no": 74,
            "serialnum": 74,
            "datatypetag": 0,
            "unit": "KV",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696669986000,
            "id": "4d1674e52604433b95b3ada0db0aef29",
            "name": "C相电压谐波",
            "no": 75,
            "serialnum": 75,
            "datatypetag": 0,
            "unit": "KV",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696670009000,
            "id": "65c7f6462ed84cda924220feeab96713",
            "name": "A相电流谐波",
            "no": 76,
            "serialnum": 76,
            "datatypetag": 0,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696670025000,
            "id": "0b4e1c9866f447bbb4367a83dc139d26",
            "name": "B相电流谐波",
            "no": 77,
            "serialnum": 77,
            "datatypetag": 0,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696670041000,
            "id": "4aa52b7fc17a461383880468cc46b4b4",
            "name": "C相电流谐波",
            "no": 78,
            "serialnum": 78,
            "datatypetag": 0,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696670943000,
            "id": "c976398a97fc457bb7181f2af08f00e3",
            "name": "相电压基波",
            "no": 79,
            "serialnum": 79,
            "datatypetag": 0,
            "unit": "KV",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1696671077000,
            "id": "b6524d5e0424454dbc0f349eec5b0fd6",
            "name": "相电流基波",
            "no": 80,
            "serialnum": 80,
            "datatypetag": 0,
            "unit": "A",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          },
          {
            "createTime": 1702449160000,
            "id": "c7fa8b59c2284ce0b8f60e5d621506e3",
            "name": "23",
            "no": 81,
            "serialnum": 81,
            "datatypetag": 0,
            "unit": "2",
            "isvisable": 0,
            "entityName": "AppTypeGroup"
          }
        ],
        typeOptions: [],
        listData: {
          "Page": 1,
          "Rows": 10
        },

        columns: [
          {
            name: "编码",
            key: "typeCode",
            width: 90,
            al: 'center'
          },{
            name: "单位转换系数",
            key: "translateRatio",
            width: 90,
            al: 'center'
          },{
            name: "折标系数",
            key: "coefficient",
            width: 90,
            al: 'center'
          },
          {
            name: "碳转换系数",
            key: "co2TranslateRatio",
            width: 90,
            al: 'center'
          },
        ],
      };
    },
    watch: {
      'temp.appType': function(val) {
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      }
    },
    computed: {

      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
    },
    mounted () {
      //应用类型编码


    },
    methods: {


      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 删除管理员
      delete_fn (v) {
        this.$confirm('是否删除此条内容','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteEnergyType({'typeId': v}).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.getList();
            } else {
              this.$message.error(`删除失败，${res.message}`);
            }
          })
        }).catch(() => {
          // ...
        });

      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.typeParentId=this.topLevel
            this.temp.measuringUnit=this.nowUnit.id
            this.typeOptions.forEach(item => {
              if(item.no==this.temp.appTypeNo) {
                this.temp.appTypeName=item.name
              }
            })
            saveEnergyType(this.temp).then(data => {
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.uid=this.temp.id
            this.temp.measuringUnit=this.nowUnit.id
            this.typeOptions.forEach(item => {
              if(item.no==this.temp.appTypeNo) {
                this.temp.appTypeName=item.name
              }
            })
            saveEnergyType(this.temp).then(data => {
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';

        this.temp=Object.assign({},v);

        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


      //获取列表数据
      getList () {

      },


    }
  };
</script>

<style lang="scss" scoped>
  .energysubtype {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background-color: #fff;
      padding: 12px 20px 20px 20px;

    }

    .paging {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }

    .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }


  }
</style>